import { Container, Row, Col } from "react-bootstrap";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle,FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import ReceiptIcon from '@mui/icons-material/Receipt';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import TodayIcon from '@mui/icons-material/Today';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import classes from "./Packages.module.scss"
import { useContext, useEffect, useState } from "react";
import TagIcon from '@mui/icons-material/Tag';
import InvoiceSwitch from "./InvoiceSwitch";
import PayTypeSwitch from "./PayTypeSwitch";
import { OrgIdContext } from "../../../store/orgId_context";

const PackageSelectRow2 = ({amounts=null, onPaymentTypeChange : onPaymentTypeChangeCb, onPayTypeChange : onPayTypeChangeCb, onAmountChange: onAmountChangeCb, type}) => {
    const { sessionInfo } = useContext(OrgIdContext);
    const [paymentType, setPaymentType] = useState("Invoice");
    const [payType, setPayType] = useState("Monthly");
    const [currentPayType, setCurrentPayType] = useState(null)
    const [amount, setAmount] = useState();
    const [quant, setQuant] = useState([]);
    //console.log(quant);
    useEffect(() => {
        setQuant(amounts);
        if(amounts && amounts.length>0){
            setAmount(amounts[0].value)
            if(onAmountChangeCb)
                onAmountChangeCb(amounts[0].value);
        }
            
    },[amounts])

    const onAmountChange = (e) =>{
        setAmount(e.target.value);
        if(onAmountChangeCb)
            onAmountChangeCb(e.target.value);
    }
    const onPaymentTypeChange = (e) =>{
        setPaymentType(e.target.value);
        if(onPaymentTypeChangeCb)
            onPaymentTypeChangeCb(e.target.value);
    }

    const onPayTypeChange = (e) =>{
        setPayType(e.target.value);
        if(onPayTypeChangeCb)
            onPayTypeChangeCb(e.target.value);
    }

    useEffect(() => {
        if(onPayTypeChangeCb)
            onPayTypeChangeCb(payType);
        showOrHidePopup(payType);
    },[payType]);
    useEffect(() => {
        if(onPaymentTypeChangeCb)
        onPaymentTypeChangeCb(paymentType);
    },[paymentType]);

    const showOrHidePopup = (_payType) => {
        let currPackage;
        if(type === "IEI"){
            currPackage = sessionInfo?.Extended?.CurrentPackages?.IEI_Package;
        }else if(type === "REI"){
            currPackage = sessionInfo?.Extended?.CurrentPackages?.REI_Package;
        }else if(type === "FISC"){
            currPackage = sessionInfo?.Extended?.CurrentPackages?.FISC_Package;
        }
        if(!currPackage) return setCurrentPayType(null);

        setCurrentPayType(currPackage.PayType);
    }

    return(
        <Row className="mt-3">
            {/* <Col className={`${classes["pay-prefilters"]}`}>
                <div className={`${classes["switch-title"]}`}>Payment type</div>
                <InvoiceSwitch paymentType={paymentType} setPaymentType={setPaymentType}/>
            </Col> */}
            <Col className={classes["pay-prefilters"]}>
                <div className={`${classes["switch-title"]}`}>Billing frequency</div>
                <PayTypeSwitch payType={payType} setPayType={setPayType} currentPayType={currentPayType}/>
            </Col>
            {quant && quant.length>0 && 
                <Col className={`${classes["pay-prefilters"]}`}>
                    <div className={`${classes["switch-title"]}`}>Amount</div>
                    <FormControl fullWidth>
                        {/* <InputLabel id={"amount"}>Amount</InputLabel> */}
                        <Select
                            labelId={"amount"}
                            id={"amount-select"}
                            value={amount}
                            label="Amount"
                            onChange={onAmountChange}
                        >
                            {quant.map(item => {
                                return <MenuItem value={item.value}><TagIcon className={classes["pay-icons"]}/>{item.title}</MenuItem>
                            })}
                        </Select>
                    </FormControl>
                </Col>
            }
        </Row>
    )
}

export default PackageSelectRow2;